import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/octavia/media",
  "description": "Columbus — лучшая информационно-развлекательная система для новой OCTAVIA. 10-дюймовый экран высокого разрешения. Навигация, независимая от доступа в интернет. Подробный обзор автомобиля, фото, технические характеристики, комплектации на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "Octavia Media",
  "name": "octavia-media",
  "title": "Медиасистемы ŠKODA OCTAVIA | Штатная магнитола и информационно-развлекательные системы новой Шкода Октавия 2023/2022 - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageSubHeading = makeShortcode("SimpleMainStageSubHeading");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedGallery = makeShortcode("QueriedGallery");
const ShowRoomTextBlock = makeShortcode("ShowRoomTextBlock");
const ShowRoomTextBlockTitle = makeShortcode("ShowRoomTextBlockTitle");
const ShowRoomTextBlockText = makeShortcode("ShowRoomTextBlockText");
const Slider = makeShortcode("Slider");
const SlideIcon = makeShortcode("SlideIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="right" src="/m/octava-media-kv-new.jpg" mobileSrc="/m/octava-media-kv-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageSubHeading mdxType="SimpleMainStageSubHeading">ŠKODA</SimpleMainStageSubHeading>
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ЦЕНТР УПРАВЛЕНИЯ ПОЕЗДКОЙ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    В любом современном автомобиле ŠKODA вы найдёте
    информационно-развлекательную систему с цветным сенсорным экраном. И это
    правильно: через центральный монитор OCTAVIA водитель не только управляет
    радиоприёмником и аудиоплеером — с помощью медиаустройства с большим
    дисплеем вы также можете отрегулировать работу климатической установки,
    настроить центральный замок, запрограммировать автономный стояночный
    отопитель, прочитать поступившее на телефон сообщение, выйти в интернет,
    рассчитать маршрут, а ещё, благодаря камерам, изучить обстановку вокруг
    машины.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="octavia2020-mediapage-mediacenter" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Умные технологии</DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="octavia2020-mediapage-tech" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection mdxType="DefaultPaddedSection" />
    <ShowRoomTextBlock desktopPic="/m/octava-new-phone.jpg" mobilePic="/m/octava-new-phone-mob.jpg" model="octavia" mdxType="ShowRoomTextBlock">
  <ShowRoomTextBlockTitle mdxType="ShowRoomTextBlockTitle">
    Индукционная площадка для мобильного телефона
  </ShowRoomTextBlockTitle>
  <ShowRoomTextBlockText main key="main" mdxType="ShowRoomTextBlockText">
    На центральной консоли, перед рычагом коробки передач, опционально
    устанавливается индукционная площадка для мобильного телефона — Phone Box.
    Она обеспечивает беспроводное соединение аппарата с внешней антенной
    автомобиля, что улучшает качество сигнала при разговорах по громкой связи и
    снижает уровень вредного электромагнитного фона в салоне.
  </ShowRoomTextBlockText>
    </ShowRoomTextBlock>
    <DefaultPaddedSection bgColor="#FAFAFA" noPt mdxType="DefaultPaddedSection">
  <Slider slidesToShow={1} mdxType="Slider">
    <SlideIcon key="/m/subscribe.svg" icon="/m/subscribe.svg" title="Подписаться" text=" Подпишитесь на новости о ŠKODA" buttonText="Подписаться на новости" buttonLink="/subscribe" mdxType="SlideIcon" />
  </Slider>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      